import ArtifactGroupType from "@/roc/museum/base/ArtifactGroupType";

const JollyRoger = {
  id: '91',
  name: 'Jolly Roger',
  groupIcon: 'LegendsOfTheHighSeas',
  type: ArtifactGroupType.LEGENDS_OF_THE_HIGH_SEAS,
  icon: 'JollyRoger',
  power: 10
};

export default JollyRoger;
